import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ensureMathIsReady, ensureMathRendered } from './mathRenderingUtils';
import { ensureImagesLoaded } from './printUtils';
export var ensureRCEContentIsLoaded = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ensureMathIsReady().then(ensureMathRendered).then(ensureImagesLoaded));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function ensureRCEContentIsLoaded() {
    return _ref.apply(this, arguments);
  };
}();